import { EEntityTypeName } from "@app/shared/enums/entity-type.enum";
import { EDocumentGenerationStatus } from "@app/shared/types/policy-document.type";

export enum EBrowserNotifyType {
  RenewCompleated = 0,
  DraftPolicyCreatedFromBulkRenew = 1,
  CoiGenerationDone = 2,
  CoiGenerationFailed = 3,
  ApprovalTaskAssigned = 4,
  ApprovalTaskApproved = 5,
  ApprovalTaskRejected = 6,
  DocumentStatusChanged = 7,
  BulkOperationCompleted = 8,
}

export interface TDocumentStatusChanged {
  documentFileId: string;
  status: EDocumentGenerationStatus;
  fileUri: string | null;
  entityType: EEntityTypeName | null;
  entityId: string | null;
  policyId: string | null;
  clientId: string | null;
}
